/**
 * OMNIVASO i18n Module — Japanese (ja)
 * Hand-curated. All keys must mirror en.js exactly.
 * Locale: ja-JP  |  hreflang: ja
 */
const ja = {
    nav: {
        home:            'ホーム',
        shop:            'ショップ',
        cart:            'カート',
        search:          '検索',
        articles:        '記事',
        blog:            'ブログ',
        about:           '概要',
        contact:         'お問い合わせ',
        account:         'マイアカウント',
        orders:          '注文履歴',
        login:           'ログイン',
        logout:          'ログアウト',
        openMenu:        'メニューを開く',
        closeMenu:       'メニューを閉じる',
        skipToContent:   'コンテンツへスキップ',
    },

    actions: {
        readMore:        '続きを読む',
        viewAll:         'すべて見る',
        learnMore:       '詳しく見る',
        back:            '戻る',
        close:           '閉じる',
        save:            '保存',
        cancel:          'キャンセル',
        submit:          '送信',
        confirm:         '確認',
        delete:          '削除',
        edit:            '編集',
        add:             '追加',
        remove:          '削除',
        search:          '検索',
        reset:           'リセット',
        next:            '次へ',
        previous:        '前へ',
        loading:         '読み込み中...',
        tryAgain:        '再試行',
        copy:            'コピー',
        share:           'シェア',
        download:        'ダウンロード',
        upload:          'アップロード',
        apply:           '適用',
        clear:           'クリア',
    },

    status: {
        success:         '成功！',
        error:           'エラーが発生しました。もう一度お試しください。',
        saved:           '正常に保存されました。',
        notFound:        'ページが見つかりません。',
        comingSoon:      '近日公開予定。',
        outOfStock:      '在庫切れ',
        inStock:         '在庫あり',
        soldOut:         '売り切れ',
        new:             '新着',
        sale:            'セール',
        featured:        '注目',
        noResults:       '結果が見つかりませんでした。',
        required:        'このフィールドは必須です。',
        invalidEmail:    '有効なメールアドレスを入力してください。',
    },

    shop: {
        addToCart:       'カートに追加',
        addedToCart:     'カートに追加しました',
        viewCart:        'カートを見る',
        checkout:        'チェックアウト',
        continueShopping:'ショッピングを続ける',
        orderSummary:    '注文概要',
        orderTotal:      '注文合計',
        subtotal:        '小計',
        shipping:        '送料',
        tax:             '税金',
        discount:        '割引',
        couponCode:      'クーポンコード',
        applyCoupon:     'クーポンを適用',
        quantity:        '数量',
        price:           '価格',
        total:           '合計',
        remove:          '削除',
        emptyCart:       'カートは空です。',
        browseProducts:  '商品を見る',
        product:         '商品',
        products:        '商品',
        category:        'カテゴリー',
        categories:      'カテゴリー',
        sortBy:          '並び替え',
        filterBy:        '絞り込み',
        allProducts:     'すべての商品',
        searchProducts:  '商品を検索...',
        productDetails:  '商品詳細',
        relatedProducts: '関連商品',
        stockLeft:       '点在庫あり',
        freeShipping:    '送料無料',
        placeOrder:      '注文を確定する',
        orderConfirmed:  'ご注文を受け付けました！',
        trackOrder:      '注文を追跡',
        orderNumber:     '注文番号',
        paymentMethod:   '支払い方法',
        billingAddress:  '請求先住所',
        shippingAddress: '配送先住所',
        firstName:       '名',
        lastName:        '姓',
        email:           'メールアドレス',
        phone:           '電話番号',
        address:         '住所',
        city:            '市区町村',
        province:        '都道府県 / 州',
        postalCode:      '郵便番号',
        country:         '国',
        secureCheckout:  '安全なチェックアウト',
        payWith:         'お支払い方法',
    },

    articles: {
        by:              '著者：',
        publishedOn:     '公開日：',
        minuteRead:      '分で読めます',
        tags:            'タグ',
        share:           'この記事をシェア',
        relatedArticles: '関連記事',
        allArticles:     'すべての記事',
        noArticles:      '記事が見つかりませんでした。',
        searchArticles:  '記事を検索...',
    },

    search: {
        placeholder:     '商品・記事・ページを検索...',
        results:         '検索結果',
        noResults:       '検索結果が見つかりませんでした：',
        searching:       '検索中...',
        searchTip:       '⌘K または Ctrl+K で検索',
        quickSearch:     'クイック検索',
    },

    newsletter: {
        subscribe:       '登録する',
        subscribeTitle:  '最新情報をお届け',
        subscribeDesc:   '最新情報をメールボックスにお届けします。',
        emailPlaceholder:'メールアドレスを入力',
        thankYou:        'ご登録ありがとうございます！',
        alreadySubscribed:'すでに登録済みです。',
        privacyNote:     'プライバシーを尊重します。いつでも登録解除できます。',
    },

    footer: {
        rights:          '無断複製・転載を禁じます。',
        privacy:         'プライバシーポリシー',
        terms:           '利用規約',
        sitemap:         'サイトマップ',
        poweredBy:       'Powered by',
        contactUs:       'お問い合わせ',
        followUs:        'フォローする',
        quickLinks:      'クイックリンク',
    },

    forms: {
        email:           'メールアドレス',
        password:        'パスワード',
        confirmPassword: 'パスワードの確認',
        username:        'ユーザー名',
        name:            '名前',
        message:         'メッセージ',
        subject:         '件名',
        send:            '送信',
        sending:         '送信中...',
        sent:            'メッセージを送信しました！',
        signIn:          'ログイン',
        signUp:          '新規登録',
        forgotPassword:  'パスワードをお忘れですか？',
        rememberMe:      'ログイン状態を保持する',
        changePassword:  'パスワードを変更',
        currentPassword: '現在のパスワード',
        newPassword:     '新しいパスワード',
    },

    i18n: {
        selectLanguage:  '言語を選択',
        language:        '言語',
    },

    errors: {
        pageNotFound:    'ページが見つかりません',
        pageNotFoundDesc:'お探しのページは存在しないか、移動した可能性があります。',
        goHome:          'ホームへ戻る',
        somethingWrong:  'エラーが発生しました',
        somethingWrongDesc: '予期しないエラーが発生しました。データは安全です。',
        returnToStorefront: 'ストアに戻る',
    },
};

export default ja;
